<template>
  <div class="inputRange">
    <input
      type="range"
      :min="inputMin"
      :max="inputMax"
      :step="inputStep"
      class="range"
      v-model="inputValue"
      @change="setValue">
    <div class="rangeStep" :style="stepStyle"></div>
    <div v-if="minLabel || maxLabel" class="rangeLabel">
      <span v-if="minLabel" class="minLabel">{{ minLabel }}</span>
      <span v-if="maxLabel" class="maxLabel">{{ maxLabel }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputRange',
  props: {
    min: {
      type: [Number, String],
      default: 1
    },
    max: {
      type: [Number, String],
      default: 5
    },
    step: {
      type: [Number, String],
      default: 1
    },
    value: {
      type: [Number, String],
      default: 1
    },
    minLabel: {
      type: String,
      default: null
    },
    maxLabel: {
      type: String,
      default: null
    }
  },
  computed: {
    stepStyle () {
      const numMarkers = this.stepCount
      const layers = Array(numMarkers)
        .fill("linear-gradient(#e0e0e0, #e0e0e0) no-repeat")
        .join(", ")
        const positions = []
      for (let i = 0; i < numMarkers; i++) {
        // numMarkers가 1이면 0%로, 아니면 i/(numMarkers-1)*100 계산
        const pos = numMarkers > 1 ? (i / (numMarkers - 1)) * 100 : 0
        positions.push(`${pos}% 0`)
      }
      const bgPositions = positions.join(", ")
      return {
        background: layers,
        backgroundSize: '2px 100%',
        backgroundPosition: bgPositions
      }
    }
  },
  watch: {
    value (newValue) {
      this.inputValue = parseInt(newValue) || this.inputMin // 비동기 값이 들어오면 업데이트
    }
  },
  created () {
    this.init()
  },
  data () {
    return {
      inputMin: 1,
      inputMax: 5,
      inputStep: 1,
      inputValue: 3,
      stepCount: 1
    }
  },
  methods: {
    init () {
      const min = parseInt(this.min)
      const max = parseInt(this.max)
      const step = parseInt(this.step)
      const value = parseInt(this.value) || min
      this.inputMin = min
      this.inputMax = max
      this.inputStep = step
      this.inputValue = value
      this.stepCount = Math.floor((max - min) / step) + 1
    },
    setValue () {
      this.$emit('setRange', parseInt(this.inputValue))
    }
  }
}
</script>

<style lang="scss" scoped>
.inputRange {
  position: relative;
  margin-bottom: 15px;
  input[type="range"] {
    position: relative;
    z-index: 1;
  }
}
.rangeStep {
  position: absolute;
  top: 10px;
  left: 0;
  width: calc(100% - 20px);
  height: 16px;
  margin-left: 10px;
  margin-right: 10px;
}
.rangeLabel {
  display: flex;
  margin-top: 4px;
  font-size: 12px;
  color: $color-grey;
  .maxLabel {
    margin-left: auto;
  }
}
</style>
